/**
 * Shared date helpers for Colonial.
 */

const PLACEHOLDER_PREFIX = '0001-';
const PLACEHOLDER_FULL = '0001-01-01';

export const isPlaceholderDate = (date) => {
  return date === PLACEHOLDER_FULL || (typeof date === 'string' && date.startsWith(PLACEHOLDER_PREFIX));
};

export const toDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const toLocalDay = (value) => {
  if (!value) return null;

  if (typeof value === 'string') {
    const dateOnlyMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
  }

  const date = toDate(value);
  if (!date) return null;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

/**
 * Calculates active days between two dates; clamps negatives to zero.
 */
export const calculateActiveDays = (startDate, endDate = null) => {
  const start = toLocalDay(startDate);
  if (!start || start.getFullYear() <= 1900 || isPlaceholderDate(startDate)) {
    return '-';
  }

  let end = toLocalDay(endDate);
  if (!end || end.getFullYear() <= 1900 || isPlaceholderDate(endDate)) {
    end = toLocalDay(new Date());
  }

  const diff = end.getTime() - start.getTime();
  return Math.max(0, Math.floor(diff / (1000 * 60 * 60 * 24)));
};

export const formatDateISO = (date = new Date()) => {
  const normalized = toDate(date) ?? new Date();
  const year = normalized.getFullYear();
  const month = String(normalized.getMonth() + 1).padStart(2, '0');
  const day = String(normalized.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
